export enum SonyLoginSteps {
  WAITING_FOR_REDIRECT_MESSAGE = "Waiting for redirect to Sony's login page",
  WAITING_FOR_LOGIN_TO_SONY_MESSAGE = "Waiting for login to Sony's system",
  WAITING_FOR_FETCH_TOKEN = "Waiting for redirect to Sony's upload",
}
